import { Suspense, lazy } from 'react';

import { MobileDashboardHeaderProps } from './MobileDashboardHeader';

const MobileDashboardHeaderAsync = lazy(
  () => import('./MobileDashboardHeader'),
);

export const MobileDashboardHeader = (props: MobileDashboardHeaderProps) => {
  return (
    <Suspense fallback={null}>
      <MobileDashboardHeaderAsync {...props} />
    </Suspense>
  );
};
